import React from "react";
import PropTypes from "prop-types";

import ValidationMessage from "./ValidationMessage";

const ValidationGroup = (props) => {

    const {
        validationMessages,
        validationMessageType,
        children,
        cols,
        colsBefore
    } = props;

    const HasValidationMessages = validationMessages !== undefined;
    const colsBeforeClass = "o-col-" + (colsBefore ? colsBefore : 12);
    const colsValidationClass = "o-col-" + (colsBefore ? 12 - colsBefore : 12);
    const colsClass = "o-col-" + (cols ? cols : 12);
    const className = HasValidationMessages ? colsClass : null;
    const style = HasValidationMessages ? { border: "1px solid #c6005b", paddingTop: "15px", marginBottom: "15px" } : null;

    return (
        <div>
            <div className={className} style={style}>{children}</div>
            {HasValidationMessages && colsBeforeClass ? <div className={"u-clear " + colsBeforeClass}>&nbsp;</div> : null}
            {HasValidationMessages ? <div className={"u-clear " + colsValidationClass}><ValidationMessage validationMessage={validationMessages} type={validationMessageType} /></div> : null}
        </div>
    );
};

ValidationGroup.propTypes = {
    validationMessages: PropTypes.string,
    validationMessageType: PropTypes.string,
    children: PropTypes.node,
    cols: PropTypes.number,
    colsBefore: PropTypes.number
};

export default ValidationGroup;